<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card card-body">
        <div class="col-12 text-center g">
            <h4>
                اشتراك في اداة المساعد الذكي
            </h4>
        </div>
        <div class="col-12" v-if="havecode">
            <div class="alert alert-success text-center g">
                <h4>
                    انت الان تستخدم كود التخفيض {{ code }}
                <br>
                سيتم تطبيق التخفيض عند الدفع.
                </h4>
            </div>
        </div>
        <div class="form-group g">
          <h5 for="">الاسم</h5>
          <input type="text"
            class="form-control" v-model="name">
        </div>
        <div class="form-group g">
          <h5 for="">رقم الجوال</h5>
          <input type="text"
            class="form-control" v-model="phone">
            <small>لارسال الفاتورة عليه</small>
        </div>
        <div class="g">
            <b-form-checkbox
                checked="true"
                name="check-button"
                inline
                value="1"
                v-model="plan"
                >
                <span>150 ريال</span> <span>لنهاية العام الدراسي</span>
                </b-form-checkbox>
        </div>
        <!-- <div class="g">
            <b-form-checkbox
                checked="true"
                name="check-button"
                inline
                value="1"
                v-model="plan"
                >
                <span>150 ريال</span> <span>لمدة 100 يوم</span>
                </b-form-checkbox>
        </div>
        <div class="g">
            <b-form-checkbox
                checked="true"
                name="check-button"
                inline
                value="2"
                v-model="plan"
                >
                <span>300 ريال</span> <span>لمدة 200 يوم </span>
                </b-form-checkbox>
        </div>
        <div class="g">
            <b-form-checkbox
                checked="true"
                name="check-button"
                inline
                value="3"
                v-model="plan"
                >
                <span>400 ريال</span> <span>لمدة 300 يوم</span>
                </b-form-checkbox>
        </div> -->
        <small class="g">سيتم اضافة 15% على المبلغ للضريبة</small>
        <div class="row">
            <div class="col-12 text-center">
                <!-- <button class="btn btn-primary" @click="done()" v-if="!loading">
                    <i class="fa fa-check"></i>
                    اشتراك الآن
                </button> -->
                <div class="mysr-form"></div>
                <template v-if="paymethod == ''">
                    <button class="btn btn-block" style="background: #9929EA; color: #fff" @click="paymethod='stcpay'; done('stcpay')" v-b-modal.pay>
                        <img :src="require('@/assets/images/stc.svg')" style="width: 24px">
                        دفع بـ STC Pay
                    </button> 
                    <button class="btn btn-dark btn-block" @click="paymethod='applepay'; done('applepay')" v-b-modal.pay>
                        <i class="fa fa-apple"></i>
                        دفع Apple Pay
                    </button> 
                    <button class="btn btn-success btn-block" @click="paymethod='creditcard'; done('creditcard')" v-b-modal.pay>
                        <i class="fa fa-cc-visa"></i>
                        دفع بالفيزا
                    </button> 
                </template>
                <!-- <button class="btn btn-primary disabled" v-if="loading">
                    جاري التحميل...
                </button> -->
            </div>
            <!-- <div class="col-12 col-lg-3">
                <input type="text" placeholder="كود الترويج" v-model="code" style="border:1px solid #eee; width: 100px; text-align: center">
            </div> -->
        </div>
    </div>
    <div class="card card-body">
        <p>تنويه:</p>
        <small>
            <ul>
                <li>
                    اﻻشتراك صالح لحساب مدرستى واحد
                </li>
                <li>
                    كل مدرسة داخل الحساب تتطلب اشتراك منفصل
                </li>
                <li>
                    يمكن تشغيل الاداة على اكثر من جهاز بنفس الاشتراك
                </li>
                <li>
                   أقصى تاريخ للإشتراك هو نهاية العام الدراسي <span dir="ltr">2026-08-01</span>.
                </li>
            </ul>
        </small>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";
export default {
  components: {
    BFormCheckbox
  },
    data(){
        return {
            loading: false,
            name: "",
            phone: "",
            plan: 1,
            paymethod: "",
            havecode: window?.location?.href?.split("code=")[1] ? true : false,
            code: window?.location?.href?.split("code=")[1] ?? "",
            school_id: window?.location?.href?.split("school_id=")[1]?.split("&")[0] ??localStorage.getItem('school_id')
        }
    },
    created(){
        if(window.location.href.includes("-c-")){
            window.location = window.location.href.replace("-c-", "&code=")
        }
        if(window.location.href.includes("callback")){
            if(window.location.href.includes("status=paid")){
                alert("تم الدفع بنجاح!", 100)
            }else{
                alert(decodeURI(window.location.href.split("message=")[1]) ,200)
            }
        }
    },
    methods: {
        done(m){
            var g = this;
            if(!this.name || !this.phone){
                alert("برجاء كتابة الاسم ورقم الجوال")
                g.paymethod = ""
                return;
            }
            this.loading = true
            $.post(api + '/api/subscribe/create-order', {
                school_id: g.school_id,
                plan: this.plan,
                name: this.name,
                phone: this.phone,
                m: 'yes',
                code: this.code
            })
            .then(function(r){
                if(r.status == 100){
                    if(m == 'applepay'){
                        Moyasar.init({
                            element: '.mysr-form',
                            amount: r.response.amount,
                            currency: 'SAR',
                            description: 'naqar ' + r.response.o,
                            publishable_api_key: r.response.token,
                            callback_url: api + '/api/subscribe/afterpayment-m?order_id=' + r.response.order_id,
                            supported_networks: ['visa', 'mastercard', 'mada'],
                            methods: ['applepay'],
                            apple_pay: {
                            country: 'SA',
                            label: 'brmja.com',
                            validate_merchant_url: 'https://api.moyasar.com/v1/applepay/initiate',
                            },
                        });
                        if(m == 'applepay'){
                            var tx = setInterval(() => {
                            if($("apple-pay-button").length){
                                clearInterval(tx)
                                setTimeout(() => {
                                    $("apple-pay-button").click()
                                }, 500);
                                }
                            }, 10);
                        }
                    }else{
                        Moyasar.init({
                            element: '.mysr-form',
                            amount: r.response.amount,
                            currency: 'SAR',
                            description: 'naqar ' + r.response.o,
                            publishable_api_key: r.response.token,
                            callback_url: api + '/api/subscribe/afterpayment-m?order_id=' + r.response.order_id,
                            methods: [m]
                        });
                    }
                    var t = setInterval(() => {
                        if($(".mysr-form button").length){
                            clearInterval(t)
                            $("footer").remove()
                            $(".mysr-form").css('padding-top', "20px")
                            if(m == 'stcpay'){
                                $(".mysr-form button").click()
                            }
                        }
                    }, 10);
                }else{
                    g.paymethod = "";
                    alert("حدث خطأ, " + r.response, 200)
                }
            })
            .fail(function(){
                g.loading = false
                alert("حدث خطأ")
            })
        }
    }
}
</script>

<style>

</style>